import React from 'react';
import { Box, Typography, SvgIcon } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { WHITESMOKE_HEX } from '../../theme';

interface FeatureBulletProps {
  icon: React.ReactElement<SvgIconProps>;
  text: string;
}

export default function FeatureBullet({ icon, text }: FeatureBulletProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '2rem',
          height: '2rem',
          borderRadius: '50%',
          backgroundColor: '#4285f4',
          flexShrink: 0,
        }}
      >
        {React.cloneElement(icon, {
          sx: {
            fontSize: '1rem',
            color: WHITESMOKE_HEX,
          },
        })}
      </Box>
      <Typography
        sx={{
          fontSize: { xs: '1rem', sm: '1.1rem' },
          fontWeight: 500,
          color: 'text.primary',
          lineHeight: 1.3,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
